import { Component, createElement, Children, Fragment, cloneElement } from 'react';
import { a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { findDOMNode } from 'react-dom';
import elementResizeDetectorMaker from 'element-resize-detector';

class ContainerDimensions extends Component {
  static getDomNodeDimensions(node) {
    const {
      top,
      right,
      bottom,
      left,
      width,
      height
    } = node.getBoundingClientRect();
    return {
      top,
      right,
      bottom,
      left,
      width,
      height
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      initiated: false
    };
    this.onResize = this.onResize.bind(this);
  }
  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    this.parentNode = findDOMNode(this).parentNode;
    this.elementResizeDetector = elementResizeDetectorMaker({
      strategy: 'scroll',
      callOnAdd: false
    });
    this.elementResizeDetector.listenTo(this.parentNode, this.onResize);
    this.componentIsMounted = true;
    this.onResize();
  }
  componentWillUnmount() {
    this.componentIsMounted = false;
    this.elementResizeDetector.uninstall(this.parentNode);
  }
  onResize() {
    const clientRect = ContainerDimensions.getDomNodeDimensions(this.parentNode);
    if (this.componentIsMounted) {
      this.setState(_objectSpread2({
        initiated: true
      }, clientRect));
    }
  }
  render() {
    if (!this.state.initiated) {
      return /*#__PURE__*/createElement("div", null);
    }
    if (typeof this.props.children === 'function') {
      const renderedChildren = this.props.children(this.state);
      return renderedChildren && Children.only(renderedChildren);
    }
    const children = /*#__PURE__*/createElement(Fragment, null, this.props.children);
    return Children.only(/*#__PURE__*/cloneElement(children, this.state));
  }
}

export default ContainerDimensions;
